import { FunctionComponent } from 'react';
import VdrWordmark from '../../../components/brand/VdrWordmark';
import logoUaiCentra from '../../../img/logo-uai-centra.png';
import '../../../css/PublicAboutUsPage.css';
const Component01: FunctionComponent = () => {
  return (
    <div className='public-about-us-page-component-one-container vdr-about-panel'>
      <div className='vdr-section-head vdr-about-section-head'>
        <h2 className='public-about-us-page-subtitle-text'>
          VisiónDERRED: Innovación, Conocimiento y Compromiso en la Gestión y análisis de Redes de
          Distribución Eléctricas.
        </h2>
        <small>Presentación</small>
      </div>
      <div className='vdr-about-intro'>
        <p className='public-about-us-page-text vdr-about-lead'>
          En VisiónDERRED, somos un equipo comprometido con la evolución de la distribución
          eléctrica. Nos dedicamos a ofrecer soluciones tecnológicas avanzadas para la gestión y
          análisis de redes eléctricas de distribución, ayudando a empresas e instituciones a
          centralizar su información de infraestructura y apoyar el proceso de planificación y
          evaluación preliminar de conexión de proyectos. Gracias a nuestra experiencia y
          conocimiento, trabajamos con el objetivo de habilitar un entorno que facilite la
          descentralización y la transición energética.
        </p>
        {/* Logotipo del proyecto y co-marca oficial UAI | CENTRA, institución ejecutora. */}
        <figure className='public-about-us-page-componente-one-img vdr-about-brand'>
          <VdrWordmark onDark size='lg' withMark />
          <figcaption className='vdr-about-brand-caption'>
            <img
              className='vdr-about-brand-cologo'
              src={logoUaiCentra}
              alt='Universidad Adolfo Ibáñez · CENTRA'
            />
          </figcaption>
        </figure>
      </div>
    </div>
  );
};

export default Component01;
